/**
 * Suleman Tech — Universal Custom Product Builder
 * Theme-native preview + upload + variants → Shopify cart properties.
 * No Printful secrets in the browser.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-custom-builder]');
  if (!root) return;

  const cfg = JSON.parse(root.getAttribute('data-builder-config') || '{}');
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} €';
  const maxMb = Number(cfg.maxFileMb || root.dataset.maxMb || 10);
  const maxBytes = maxMb * 1024 * 1024;
  const allowed = (cfg.allowedTypes || ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml']);
  const storageKey = 'st-cb-design-v1';

  const FAMILY_PRESETS = {
    tshirt: {
      printAreas: { front: { x: 0.32, y: 0.26, w: 0.36, h: 0.4 }, back: { x: 0.32, y: 0.26, w: 0.36, h: 0.4 } },
      views: ['front', 'back'],
      showColor: true,
      showSize: true,
      minPrintPx: 1500,
    },
    hoodie: {
      printAreas: { front: { x: 0.34, y: 0.3, w: 0.32, h: 0.34 }, back: { x: 0.34, y: 0.28, w: 0.32, h: 0.36 } },
      views: ['front', 'back'],
      showColor: true,
      showSize: true,
      minPrintPx: 1500,
    },
    mug: {
      printAreas: { front: { x: 0.22, y: 0.28, w: 0.48, h: 0.42 } },
      views: ['front'],
      showColor: true,
      showSize: false,
      minPrintPx: 1200,
    },
    tote: {
      printAreas: { front: { x: 0.28, y: 0.32, w: 0.44, h: 0.4 } },
      views: ['front'],
      showColor: true,
      showSize: false,
      minPrintPx: 1400,
    },
    poster: {
      printAreas: { front: { x: 0.08, y: 0.08, w: 0.84, h: 0.84 } },
      views: ['front'],
      showColor: false,
      showSize: true,
      minPrintPx: 2000,
    },
    phone_case: {
      printAreas: { front: { x: 0.22, y: 0.12, w: 0.56, h: 0.76 } },
      views: ['front'],
      showColor: true,
      showSize: false,
      showPhoneModel: true,
      minPrintPx: 1000,
    },
    gift: {
      printAreas: { front: { x: 0.25, y: 0.25, w: 0.5, h: 0.5 } },
      views: ['front'],
      showColor: true,
      showSize: true,
      minPrintPx: 1200,
    },
    embroidery: {
      printAreas: { front: { x: 0.36, y: 0.28, w: 0.28, h: 0.22 } },
      views: ['front'],
      showColor: true,
      showSize: true,
      minPrintPx: 800,
    },
    packaging: {
      printAreas: { front: { x: 0.2, y: 0.2, w: 0.6, h: 0.6 } },
      views: ['front'],
      showColor: false,
      showSize: true,
      minPrintPx: 1500,
    },
  };

  const COLOR_MAP = {
    negro: '#111111', black: '#111111', blanco: '#f5f5f5', white: '#f5f5f5',
    gris: '#9ca3af', grey: '#9ca3af', gray: '#9ca3af', navy: '#1e3a5f',
    azul: '#2563eb', blue: '#2563eb', rojo: '#dc2626', red: '#dc2626',
    verde: '#16a34a', green: '#16a34a', rosa: '#ec4899', pink: '#ec4899',
    amarillo: '#eab308', yellow: '#eab308', naranja: '#f97316', orange: '#f97316',
    beige: '#d6c6a8', marron: '#78350f', brown: '#78350f',
  };

  const els = {
    canvas: root.querySelector('[data-cb-canvas]'),
    stage: root.querySelector('[data-cb-stage]'),
    views: root.querySelector('[data-cb-views]'),
    drop: root.querySelector('[data-cb-drop]'),
    fileInput: root.querySelector('[data-cb-file]'),
    fileCard: root.querySelector('[data-cb-file-card]'),
    fileThumb: root.querySelector('[data-cb-file-thumb]'),
    fileName: root.querySelector('[data-cb-file-name]'),
    fileSize: root.querySelector('[data-cb-file-size]'),
    fileStatus: root.querySelector('[data-cb-file-status]'),
    quality: root.querySelector('[data-cb-quality]'),
    error: root.querySelector('[data-cb-error]'),
    replaceBtn: root.querySelector('[data-cb-replace]'),
    deleteBtn: root.querySelector('[data-cb-delete]'),
    controls: root.querySelector('[data-cb-controls]'),
    optionsHost: root.querySelector('[data-cb-options]'),
    qtyInput: root.querySelector('[data-cb-qty]'),
    priceProduct: root.querySelector('[data-cb-price-product]'),
    priceTotal: root.querySelector('[data-cb-price-total]'),
    stickyPrice: root.querySelector('[data-cb-sticky-price]'),
    form: root.querySelector('#CustomBuilderForm'),
    variantId: root.querySelector('[data-cb-variant-id]'),
    props: {
      design: root.querySelector('[name="properties[Diseño]"]'),
      area: root.querySelector('[name="properties[Área de impresión]"]'),
      quality: root.querySelector('[name="properties[Calidad de impresión]"]'),
      config: root.querySelector('[name="properties[_product_configuration]"]'),
      preview: root.querySelector('[name="properties[_design_preview]"]'),
      note: root.querySelector('[name="properties[Personalización]"]'),
    },
    zoomBtn: root.querySelector('[data-cb-zoom]'),
    fullBtn: root.querySelector('[data-cb-fullscreen]'),
    fullscreen: root.querySelector('[data-cb-fullscreen-layer]'),
    fullCanvas: root.querySelector('[data-cb-fullscreen-canvas]'),
    fullClose: root.querySelector('[data-cb-fullscreen-close]'),
    sticky: root.querySelector('[data-cb-sticky]'),
    stickyAdd: root.querySelector('[data-cb-sticky-add]'),
  };

  const variants = (() => {
    try {
      return JSON.parse(root.querySelector('[data-cb-variants]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  })();

  const productImages = (() => {
    try {
      return JSON.parse(root.querySelector('[data-cb-images]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  })();

  const familyKey = detectFamily(cfg.family || root.dataset.family || '');
  const family = Object.assign({}, FAMILY_PRESETS[familyKey] || FAMILY_PRESETS.gift, cfg.ui || {});
  if (cfg.printAreas) family.printAreas = cfg.printAreas;

  const state = {
    view: (family.views && family.views[0]) || 'front',
    mockupImg: null,
    designImg: null,
    designMeta: null,
    qualityLabel: '',
    transform: { x: 0, y: 0, scale: 1, rotate: 0 },
    drag: null,
    zoom: 1,
    selectedOptions: {},
  };

  const ctx = els.canvas.getContext('2d');
  let drawRaf = 0;

  function detectFamily(raw) {
    const t = String(raw).toLowerCase();
    if (/hoodie|sudadera|zip/.test(t)) return 'hoodie';
    if (/t-?shirt|camiseta|tee/.test(t)) return 'tshirt';
    if (/mug|taza|drink/.test(t)) return 'mug';
    if (/tote|bolsa|bag/.test(t)) return 'tote';
    if (/poster|p[oó]ster|canvas|print|wall/.test(t)) return 'poster';
    if (/phone|funda|case|iphone/.test(t)) return 'phone_case';
    if (/bordad|embroider/.test(t)) return 'embroidery';
    if (/packag|packaging|branding/.test(t)) return 'packaging';
    return 'gift';
  }

  function formatMoney(cents) {
    const n = (Number(cents) / 100).toFixed(2).replace('.', ',');
    if (window.Shopify && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, moneyFormat); } catch (_) {}
    }
    return `${n} €`;
  }

  function formatBytes(b) {
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  function currentPrintArea() {
    const areas = family.printAreas || { front: { x: 0.3, y: 0.3, w: 0.4, h: 0.4 } };
    return areas[state.view] || areas.front || Object.values(areas)[0];
  }

  function scheduleDraw() {
    if (drawRaf) return;
    drawRaf = requestAnimationFrame(() => {
      drawRaf = 0;
      draw();
    });
  }

  function sizeCanvas() {
    const rect = els.stage.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = Math.max(1, Math.floor(rect.width));
    const h = Math.max(1, Math.floor(rect.height));
    els.canvas.width = w * dpr;
    els.canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { w, h };
  }

  function draw(targetCtx, targetW, targetH) {
    const c = targetCtx || ctx;
    const { w, h } = targetW ? { w: targetW, h: targetH } : sizeCanvas();
    c.clearRect(0, 0, w, h);

    if (state.mockupImg) {
      const img = state.mockupImg;
      const scale = Math.min(w / img.naturalWidth, h / img.naturalHeight) * state.zoom;
      const dw = img.naturalWidth * scale;
      const dh = img.naturalHeight * scale;
      const dx = (w - dw) / 2;
      const dy = (h - dh) / 2;
      c.drawImage(img, dx, dy, dw, dh);

      const area = currentPrintArea();
      const ax = dx + area.x * dw;
      const ay = dy + area.y * dh;
      const aw = area.w * dw;
      const ah = area.h * dh;

      c.save();
      c.strokeStyle = 'rgba(0,240,255,0.35)';
      c.setLineDash([6, 4]);
      c.lineWidth = 1;
      c.strokeRect(ax, ay, aw, ah);
      c.restore();

      if (state.designImg) {
        c.save();
        c.beginPath();
        c.rect(ax, ay, aw, ah);
        c.clip();

        const t = state.transform;
        const cx = ax + aw / 2 + t.x;
        const cy = ay + ah / 2 + t.y;
        const base = Math.min(aw / state.designImg.naturalWidth, ah / state.designImg.naturalHeight);
        const s = base * t.scale;
        const dw2 = state.designImg.naturalWidth * s;
        const dh2 = state.designImg.naturalHeight * s;

        c.translate(cx, cy);
        c.rotate((t.rotate * Math.PI) / 180);
        c.drawImage(state.designImg, -dw2 / 2, -dh2 / 2, dw2, dh2);
        c.restore();
      }
    } else {
      c.fillStyle = '#1a2330';
      c.fillRect(0, 0, w, h);
      c.fillStyle = '#9aa4b2';
      c.font = '14px system-ui';
      c.textAlign = 'center';
      c.fillText('Cargando vista previa…', w / 2, h / 2);
    }
  }

  async function setMockupFromProduct() {
    const idx = state.view === 'back' && productImages[1] ? 1 : 0;
    const src = productImages[idx] || productImages[0] || root.dataset.featuredImage;
    if (!src) return;
    try {
      state.mockupImg = await loadImage(src);
      scheduleDraw();
    } catch (_) {
      /* keep previous */
    }
  }

  function buildViews() {
    if (!els.views) return;
    const views = family.views || ['front'];
    els.views.innerHTML = views.map((v) => {
      const label = v === 'front' ? 'Frente' : v === 'back' ? 'Espalda' : v === 'side' ? 'Lateral' : v;
      return `<button type="button" class="st-cb__view${v === state.view ? ' is-active' : ''}" data-cb-view="${v}" aria-pressed="${v === state.view}">${label}</button>`;
    }).join('');
    els.views.querySelectorAll('[data-cb-view]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        state.view = btn.dataset.cbView;
        buildViews();
        await setMockupFromProduct();
        syncHiddenProps();
      });
    });
  }

  function colorFor(label) {
    const key = String(label).toLowerCase().trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(key)) return key;
    return '#6b7280';
  }

  function isColorOption(name) {
    return /color|colour|colore/i.test(name || '');
  }

  function isSizeOption(name) {
    return /talla|size|tamaño|tamano/i.test(name || '');
  }

  function renderOptions() {
    if (!els.optionsHost) return;
    const optionNames = [];
    variants.forEach((v) => {
      [v.option1, v.option2, v.option3].forEach((o, i) => {
        if (!o) return;
        const product = window.meta?.product;
        /* option names come from liquid-rendered selects */
      });
    });

    const groups = root.querySelectorAll('[data-cb-option-group]');
    groups.forEach((group) => {
      const name = group.dataset.optionName || '';
      const values = JSON.parse(group.dataset.optionValues || '[]');
      const host = group.querySelector('[data-cb-option-ui]');
      if (!host) return;
      const selected = state.selectedOptions[name] || values[0];
      state.selectedOptions[name] = selected;

      if (isColorOption(name) && (family.showColor !== false)) {
        host.innerHTML = `<div class="st-cb__swatches" role="group" aria-label="${name}">${values.map((val) => {
          const active = val === selected ? ' is-active' : '';
          return `<button type="button" class="st-cb__swatch${active}" style="background:${colorFor(val)}" data-value="${escapeAttr(val)}" data-label="${escapeAttr(val)}" aria-label="${escapeAttr(name + ': ' + val)}" aria-pressed="${val === selected}"></button>`;
        }).join('')}</div>`;
      } else {
        host.innerHTML = `<div class="st-pdp__pills" role="group" aria-label="${name}">${values.map((val) => {
          const active = val === selected ? ' is-active' : '';
          return `<button type="button" class="st-pdp__pill${active}" data-value="${escapeAttr(val)}" aria-pressed="${val === selected}">${escapeHtml(val)}</button>`;
        }).join('')}</div>`;
      }

      host.querySelectorAll('[data-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          state.selectedOptions[name] = btn.dataset.value;
          const select = group.querySelector('[data-cb-option-select]');
          if (select) {
            select.value = btn.dataset.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          renderOptions();
          updateVariantAndPrice();
        });
      });
    });

    // Hide groups based on family flags
    groups.forEach((group) => {
      const name = group.dataset.optionName || '';
      let hide = false;
      if (isColorOption(name) && family.showColor === false) hide = true;
      if (isSizeOption(name) && family.showSize === false) hide = true;
      group.hidden = hide;
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function updateVariantAndPrice() {
    const opts = [...root.querySelectorAll('[data-cb-option-select]')].map((s) => s.value);
    const match = variants.find((v) => {
      const o = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.every((val, i) => o[i] === val);
    }) || variants.find((v) => v.available) || variants[0];

    if (!match) return;
    if (els.variantId) els.variantId.value = match.id;

    const qty = Math.max(1, Number(els.qtyInput?.value || 1));
    const unit = match.price;
    const total = unit * qty;
    const money = formatMoney(unit);
    const totalMoney = formatMoney(total);
    if (els.priceProduct) els.priceProduct.textContent = money;
    if (els.priceTotal) els.priceTotal.textContent = totalMoney;
    if (els.stickyPrice) els.stickyPrice.textContent = totalMoney;

    const buyBtns = root.querySelectorAll('[data-cb-action]');
    buyBtns.forEach((b) => { b.disabled = !match.available; });
    if (els.stickyAdd) els.stickyAdd.disabled = !match.available;
  }

  function showError(msg) {
    if (!els.error) return;
    els.error.hidden = !msg;
    els.error.textContent = msg || '';
  }

  function setQuality(label, ok) {
    state.qualityLabel = label;
    if (!els.quality) return;
    els.quality.hidden = !label;
    els.quality.textContent = label ? `Calidad de impresión: ${label}` : '';
    els.quality.classList.toggle('st-cb__quality--ok', !!ok);
    els.quality.classList.toggle('st-cb__quality--low', !ok && !!label);
  }

  async function acceptFile(file) {
    showError('');
    if (!file) return;
    if (!allowed.includes(file.type) && !/\.(png|jpe?g|webp|svg)$/i.test(file.name)) {
      showError('Usa un archivo PNG, JPG, WEBP o SVG.');
      return;
    }
    if (file.size > maxBytes) {
      showError(`El archivo supera el tamaño máximo permitido (${maxMb} MB).`);
      return;
    }

    if (els.fileStatus) els.fileStatus.textContent = 'Subiendo diseño…';
    els.drop.hidden = true;
    els.fileCard.hidden = false;

    try {
      const url = URL.createObjectURL(file);
      const img = await loadImage(url);
      const minPx = family.minPrintPx || 1200;
      const shortSide = Math.min(img.naturalWidth, img.naturalHeight);
      if (shortSide < minPx * 0.55) {
        setQuality('Baja', false);
      } else if (shortSide < minPx) {
        setQuality('Aceptable', true);
      } else {
        setQuality('Excelente', true);
      }

      state.designImg = img;
      state.designMeta = { name: file.name, size: file.size, type: file.type, objectUrl: url };
      state.transform = { x: 0, y: 0, scale: 1, rotate: 0 };

      if (els.fileThumb) els.fileThumb.src = url;
      if (els.fileName) els.fileName.textContent = file.name;
      if (els.fileSize) els.fileSize.textContent = formatBytes(file.size);
      if (els.fileStatus) els.fileStatus.textContent = 'Tu diseño está listo';
      if (els.controls) els.controls.hidden = false;

      persistDesign(file, url);
      scheduleDraw();
      syncHiddenProps();
    } catch (_) {
      showError('No hemos podido subir tu diseño. Inténtalo de nuevo.');
      resetDesign(false);
      if (els.fileStatus) els.fileStatus.textContent = '';
    }
  }

  function persistDesign(file, objectUrl) {
    try {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result;
        // Keep under localStorage budget — store only if reasonably small
        if (typeof dataUrl === 'string' && dataUrl.length < 1_800_000) {
          sessionStorage.setItem(storageKey, JSON.stringify({
            name: file.name,
            type: file.type,
            size: file.size,
            dataUrl,
            transform: state.transform,
            quality: state.qualityLabel,
          }));
        }
      };
      // Prefer compressed preview for persistence of huge files
      if (file.size > 900_000 && state.designImg) {
        const c = document.createElement('canvas');
        const max = 1200;
        const scale = Math.min(1, max / Math.max(state.designImg.naturalWidth, state.designImg.naturalHeight));
        c.width = Math.round(state.designImg.naturalWidth * scale);
        c.height = Math.round(state.designImg.naturalHeight * scale);
        c.getContext('2d').drawImage(state.designImg, 0, 0, c.width, c.height);
        sessionStorage.setItem(storageKey, JSON.stringify({
          name: file.name,
          type: 'image/jpeg',
          size: file.size,
          dataUrl: c.toDataURL('image/jpeg', 0.82),
          transform: state.transform,
          quality: state.qualityLabel,
          originalType: file.type,
        }));
      } else {
        reader.readAsDataURL(file);
      }
    } catch (_) { /* ignore quota */ }
  }

  async function restoreDesign() {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data?.dataUrl) return;
      const img = await loadImage(data.dataUrl);
      state.designImg = img;
      state.designMeta = { name: data.name, size: data.size, type: data.type, objectUrl: data.dataUrl };
      state.transform = data.transform || state.transform;
      state.qualityLabel = data.quality || '';
      setQuality(state.qualityLabel, /excelente|aceptable/i.test(state.qualityLabel || ''));
      els.drop.hidden = true;
      els.fileCard.hidden = false;
      if (els.fileThumb) els.fileThumb.src = data.dataUrl;
      if (els.fileName) els.fileName.textContent = data.name;
      if (els.fileSize) els.fileSize.textContent = formatBytes(data.size || 0);
      if (els.fileStatus) els.fileStatus.textContent = 'Tu diseño está listo';
      if (els.controls) els.controls.hidden = false;
      scheduleDraw();
      syncHiddenProps();
    } catch (_) { /* ignore */ }
  }

  function resetDesign(clearStorage) {
    if (state.designMeta?.objectUrl?.startsWith('blob:')) {
      try { URL.revokeObjectURL(state.designMeta.objectUrl); } catch (_) {}
    }
    state.designImg = null;
    state.designMeta = null;
    state.qualityLabel = '';
    state.transform = { x: 0, y: 0, scale: 1, rotate: 0 };
    els.drop.hidden = false;
    els.fileCard.hidden = true;
    if (els.controls) els.controls.hidden = true;
    setQuality('', true);
    showError('');
    if (clearStorage) sessionStorage.removeItem(storageKey);
    if (els.fileInput) els.fileInput.value = '';
    scheduleDraw();
    syncHiddenProps();
  }

  function syncHiddenProps() {
    const meta = state.designMeta;
    if (els.props.design) els.props.design.value = meta ? meta.name : '';
    if (els.props.area) {
      const labels = { front: 'Frente', back: 'Espalda', side: 'Lateral' };
      els.props.area.value = labels[state.view] || state.view;
    }
    if (els.props.quality) els.props.quality.value = state.qualityLabel || '';
    if (els.props.note) {
      els.props.note.value = meta
        ? 'Diseño personalizado subido por el cliente (vista previa orientativa)'
        : '';
    }
    if (els.props.config) {
      els.props.config.value = JSON.stringify({
        family: familyKey,
        view: state.view,
        transform: state.transform,
        file: meta ? { name: meta.name, type: meta.type, size: meta.size } : null,
        options: state.selectedOptions,
      });
    }
    // Small cart thumbnail only — never dump full artwork into properties
    if (els.props.preview && state.designImg) {
      try {
        const c = document.createElement('canvas');
        c.width = 120;
        c.height = 120;
        const cx = c.getContext('2d');
        const s = Math.min(120 / state.designImg.naturalWidth, 120 / state.designImg.naturalHeight);
        const dw = state.designImg.naturalWidth * s;
        const dh = state.designImg.naturalHeight * s;
        cx.fillStyle = '#fff';
        cx.fillRect(0, 0, 120, 120);
        cx.drawImage(state.designImg, (120 - dw) / 2, (120 - dh) / 2, dw, dh);
        const thumb = c.toDataURL('image/jpeg', 0.7);
        els.props.preview.value = thumb.length < 12000 ? thumb : '';
      } catch (_) {
        els.props.preview.value = '';
      }
    } else if (els.props.preview) {
      els.props.preview.value = '';
    }
  }

  function bindUpload() {
    const onFiles = (files) => acceptFile(files && files[0]);
    els.fileInput?.addEventListener('change', (e) => onFiles(e.target.files));
    els.replaceBtn?.addEventListener('click', () => els.fileInput?.click());
    els.deleteBtn?.addEventListener('click', () => resetDesign(true));

    ['dragenter', 'dragover'].forEach((ev) => {
      els.drop?.addEventListener(ev, (e) => {
        e.preventDefault();
        els.drop.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach((ev) => {
      els.drop?.addEventListener(ev, (e) => {
        e.preventDefault();
        els.drop.classList.remove('is-dragover');
        if (ev === 'drop') onFiles(e.dataTransfer.files);
      });
    });
  }

  function bindControls() {
    els.controls?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cb-edit]');
      if (!btn || !state.designImg) return;
      const action = btn.dataset.cbEdit;
      const t = state.transform;
      if (action === 'zoom-in') t.scale = Math.min(3, t.scale + 0.1);
      if (action === 'zoom-out') t.scale = Math.max(0.3, t.scale - 0.1);
      if (action === 'rotate') t.rotate = (t.rotate + 15) % 360;
      if (action === 'center') { t.x = 0; t.y = 0; }
      if (action === 'reset') state.transform = { x: 0, y: 0, scale: 1, rotate: 0 };
      persistTransformOnly();
      scheduleDraw();
      syncHiddenProps();
    });
  }

  function persistTransformOnly() {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return;
      const data = JSON.parse(raw);
      data.transform = state.transform;
      sessionStorage.setItem(storageKey, JSON.stringify(data));
    } catch (_) {}
  }

  function bindDrag() {
    const stage = els.stage;
    if (!stage) return;

    const pointer = (e) => {
      if (!state.designImg) return;
      const pt = e.touches ? e.touches[0] : e;
      return { x: pt.clientX, y: pt.clientY };
    };

    stage.addEventListener('pointerdown', (e) => {
      if (!state.designImg) return;
      stage.setPointerCapture(e.pointerId);
      const p = pointer(e);
      state.drag = { x: p.x, y: p.y, ox: state.transform.x, oy: state.transform.y };
      stage.classList.add('is-dragging');
    });
    stage.addEventListener('pointermove', (e) => {
      if (!state.drag) return;
      const p = pointer(e);
      state.transform.x = state.drag.ox + (p.x - state.drag.x);
      state.transform.y = state.drag.oy + (p.y - state.drag.y);
      scheduleDraw();
    });
    const end = () => {
      if (!state.drag) return;
      state.drag = null;
      stage.classList.remove('is-dragging');
      persistTransformOnly();
      syncHiddenProps();
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function bindZoomFullscreen() {
    els.zoomBtn?.addEventListener('click', () => {
      state.zoom = state.zoom >= 1.4 ? 1 : 1.4;
      scheduleDraw();
    });
    els.fullBtn?.addEventListener('click', () => {
      if (!els.fullscreen || !els.fullCanvas) return;
      els.fullscreen.hidden = false;
      const dpr = Math.min(devicePixelRatio || 1, 2);
      const w = Math.min(window.innerWidth - 32, 900);
      const h = Math.min(window.innerHeight - 32, 900);
      els.fullCanvas.width = w * dpr;
      els.fullCanvas.height = h * dpr;
      const fctx = els.fullCanvas.getContext('2d');
      fctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      // temporarily draw into fullscreen
      const prev = { canvas: els.canvas, ctx };
      // reuse draw logic with target
      const mock = state.mockupImg;
      fctx.clearRect(0, 0, w, h);
      if (mock) {
        const scale = Math.min(w / mock.naturalWidth, h / mock.naturalHeight);
        const dw = mock.naturalWidth * scale;
        const dh = mock.naturalHeight * scale;
        const dx = (w - dw) / 2;
        const dy = (h - dh) / 2;
        fctx.drawImage(mock, dx, dy, dw, dh);
        if (state.designImg) {
          const area = currentPrintArea();
          const ax = dx + area.x * dw;
          const ay = dy + area.y * dh;
          const aw = area.w * dw;
          const ah = area.h * dh;
          fctx.save();
          fctx.beginPath();
          fctx.rect(ax, ay, aw, ah);
          fctx.clip();
          const t = state.transform;
          const cx = ax + aw / 2 + t.x * (w / (els.stage.getBoundingClientRect().width || w));
          const cy = ay + ah / 2 + t.y * (h / (els.stage.getBoundingClientRect().height || h));
          const base = Math.min(aw / state.designImg.naturalWidth, ah / state.designImg.naturalHeight);
          const s = base * t.scale;
          const dw2 = state.designImg.naturalWidth * s;
          const dh2 = state.designImg.naturalHeight * s;
          fctx.translate(cx, cy);
          fctx.rotate((t.rotate * Math.PI) / 180);
          fctx.drawImage(state.designImg, -dw2 / 2, -dh2 / 2, dw2, dh2);
          fctx.restore();
        }
      }
    });
    els.fullClose?.addEventListener('click', () => {
      if (els.fullscreen) els.fullscreen.hidden = true;
    });
    els.fullscreen?.addEventListener('click', (e) => {
      if (e.target === els.fullscreen) els.fullscreen.hidden = true;
    });
  }

  function bindQty() {
    root.querySelector('[data-cb-qty-minus]')?.addEventListener('click', () => {
      els.qtyInput.value = Math.max(1, Number(els.qtyInput.value) - 1);
      updateVariantAndPrice();
    });
    root.querySelector('[data-cb-qty-plus]')?.addEventListener('click', () => {
      els.qtyInput.value = Number(els.qtyInput.value) + 1;
      updateVariantAndPrice();
    });
    els.qtyInput?.addEventListener('change', updateVariantAndPrice);
  }

  function requireDesignBeforeCart(e) {
    if (!state.designImg) {
      e.preventDefault();
      showError('Sube tu diseño antes de continuar.');
      els.drop?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    syncHiddenProps();
    return true;
  }

  function bindForm() {
    // Use theme's FormData cart path: id CustomBuilderForm handled here
    els.form?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cb-action]');
      if (!btn) return;
      // let theme.js handle #ProductForm only — we intercept our form
    });

    els.form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!requireDesignBeforeCart(e)) return;
      const btn = e.submitter || els.form.querySelector('[data-cb-action]');
      const action = btn?.getAttribute('data-cb-action') || 'add';
      btn && (btn.disabled = true);
      try {
        syncHiddenProps();
        const fd = new FormData(els.form);
        // Strip oversized preview property if any
        const preview = fd.get('properties[_design_preview]');
        if (preview && String(preview).length > 12000) {
          fd.delete('properties[_design_preview]');
        }
        const cartAdd = (window.ST_ROUTES && ST_ROUTES.cart_add) || '/cart/add.js';
        const res = await fetch(cartAdd, {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'No se pudo añadir al carrito');
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (action === 'buy') {
          window.location.href = (window.ST_ROUTES && ST_ROUTES.checkout) || '/checkout';
          return;
        }
        // Refresh drawer via theme if available
        const open = document.querySelector('[data-cart-open]');
        if (typeof window.ST_openCart === 'function') window.ST_openCart();
        else {
          // trigger theme refresh by fetching cart and clicking open
          await fetch('/cart.js');
          open?.click();
          // Force redraw of drawer
          location.hash = '';
          const drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) {
            drawer.hidden = false;
            drawer.setAttribute('aria-hidden', 'false');
          }
        }
        // Soft refresh drawer contents
        window.dispatchEvent(new Event('st:refresh-cart'));
      } catch (err) {
        alert(err.message || 'Error al añadir al carrito');
      } finally {
        if (btn) btn.disabled = false;
      }
    });

    els.stickyAdd?.addEventListener('click', () => {
      const addBtn = els.form?.querySelector('[data-cb-action="add"]');
      addBtn?.click();
    });
  }

  function bindSticky() {
    if (!els.sticky || !els.form) return;
    const onScroll = () => {
      const rect = els.form.getBoundingClientRect();
      els.sticky.hidden = rect.bottom > window.innerHeight * 0.55;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindProductSwitcher() {
    root.querySelectorAll('[data-cb-switch-product]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.cbSwitchProduct;
        if (!url || btn.classList.contains('is-selected')) return;
        // Design kept in sessionStorage across navigation
        persistTransformOnly();
        window.location.href = url;
      });
    });
  }

  // Init
  (async function init() {
    // Seed selected options from liquid selects
    root.querySelectorAll('[data-cb-option-group]').forEach((group) => {
      const name = group.dataset.optionName;
      const select = group.querySelector('[data-cb-option-select]');
      if (name && select) state.selectedOptions[name] = select.value;
    });

    buildViews();
    renderOptions();
    bindUpload();
    bindControls();
    bindDrag();
    bindZoomFullscreen();
    bindQty();
    bindForm();
    bindSticky();
    bindProductSwitcher();
    await setMockupFromProduct();
    await restoreDesign();
    updateVariantAndPrice();
    window.addEventListener('resize', scheduleDraw);

    // Expose minimal hook for theme cart refresh
    window.addEventListener('st:refresh-cart', async () => {
      try {
        const res = await fetch('/cart.js');
        if (!res.ok) return;
        const cart = await res.json();
        const body = document.querySelector('[data-cart-contents]');
        const totalEl = document.querySelector('[data-cart-total]');
        if (!body) return;
        const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        const propsHtml = (item) => {
          const props = item.properties || {};
          const lines = Object.keys(props)
            .filter((k) => k && !k.startsWith('_') && props[k])
            .map((k) => `<span class="st-cart-drawer__prop">${esc(k)}: ${esc(props[k])}</span>`)
            .join('');
          return lines ? `<div class="st-cart-drawer__props">${lines}</div>` : '';
        };
        body.innerHTML = `<ul class="st-cart-drawer__lines">${cart.items.map((item) => `
          <li class="st-cart-drawer__line">
            ${item.image ? `<img src="${esc(item.image)}" alt="" width="64" height="64" loading="lazy">` : ''}
            <div>
              <a href="${esc(item.url)}">${esc(item.product_title)}</a>
              ${propsHtml(item)}
              <p>${item.quantity} × ${(item.final_line_price / 100).toFixed(2).replace('.', ',')} €</p>
            </div>
          </li>`).join('')}</ul>`;
        if (totalEl) totalEl.innerHTML = `<strong>${(cart.total_price / 100).toFixed(2).replace('.', ',')} €</strong>`;
        const count = document.querySelectorAll('[data-cart-count]');
        count.forEach((el) => { el.textContent = String(cart.item_count); });
      } catch (_) {}
    });
  })();
})();
